import { isPlatformBrowser } from '@angular/common';
import {  ChangeDetectorRef, Component, DestroyRef, Inject, Input, OnDestroy, OnInit, PLATFORM_ID, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ParamFilters } from '@app/models/filtermodels/ParamFilters';
import { Partner } from '@app/models/partner/IPartner';
import { AcvisService } from '@app/services/acvis.service';
import { HotelFiltersService } from '@app/services/hotelfilters.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'clever-inclusive-list',
    templateUrl: './inclusive-list.component.html',
    styleUrls: ['./inclusive-list.component.scss'],
    standalone: false
})
export class InclusiveListComponent implements OnInit, OnDestroy {
    @Input() mode: string;
    @Input() partner: Partner;
    @Input() inclusiveListExt: any[];
    protected unsubscribe$ = new Subject();
    isBrowser: boolean = false;
    fromtraffics: boolean = false;
    slicenbr: number = 5;
    inclusiveList: any[] = [];
    selectedList: string[] = [];
    destroyRef = inject(DestroyRef);
    constructor(
        @Inject(PLATFORM_ID) protected platformId: any,
        protected acvisService: AcvisService,
        protected hotelService: HotelFiltersService,
        protected cdr: ChangeDetectorRef
    ) {
        this.isBrowser = isPlatformBrowser(this.platformId);
    }

    ngOnInit(): void {
        if (this.isBrowser) {
            this.initFilterSub();
            if (this.inclusiveListExt?.length > 0) {
                this.fromtraffics = true;
                const tmp = [];
                for (let i = 0; i < this.inclusiveListExt.length; i++) {
                    if (
                        this.inclusiveListExt[i].code !== 'MT' &&
                        this.inclusiveListExt[i].code !== 'OT' &&
                        this.inclusiveListExt[i].code !== 'MW' &&
                        this.inclusiveListExt[i].code !== 'CS' &&
                        this.inclusiveListExt[i].code !== 'FS' &&
                        this.inclusiveListExt[i].code !== 'CR' &&
                        this.inclusiveListExt[i].code !== 'ZG') {
                        tmp.push(this.inclusiveListExt[i]);
                    }
                }
                this.inclusiveList = this.sortArray(tmp);
            } else {
                this.initinclusiveList();
            }
        }
    }

    
    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }

    initinclusiveList(): void {
        this.acvisService.request({}, 'inclusiveList').pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe(res => {
            this.checktypes(res);
        });
    }

    checktypes(array) {
        for (let i = 0; i < array.length; i++) {
            if (this.partner?.filters?.['hideinklusive' + array[i].code + 'filter']) {
                array.splice(i, 1);
                i--;
            }
        }

        this.inclusiveList = this.sortArray(array);
        this.cdr.detectChanges();
    }

    sortArray(array): any[] {
        if (array?.length > 0) {
            array?.sort((a, b) => {
                a = a.name.toLowerCase();
                b = b.name.toLowerCase();

                return a < b ? -1 : a > b ? 1 : 0;
            });
        }
        return array;
    }

    showMore(all) {
        this.slicenbr = all;
    }

    initFilterSub(): void {
        this.hotelService.getfilters$.pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((filter: ParamFilters) => {
            this.selectedList = [];
            if (filter.inclusiveList?.length > 0) {
                for (let i = 0; i < filter.inclusiveList.length; i++) {
                    this.selectedList.push(filter.inclusiveList[i].code);
                }
            }
            this.cdr.markForCheck();
        });
    }

    selected(op): void {
        let push = true;
        if (this.selectedList.indexOf(op.code) >= 0) {
            push = false;
        }
        this.hotelService.inclusiveList(op, push, this.mode !== 'home');
        this.cdr.markForCheck();
    }
}
